<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.2899 62.9957C16.6289 64.3348 18.7997 64.3348 20.1387 62.9957L48.7101 34.4243C50.049 33.0854 50.049 30.9145 48.7101 29.5756L20.1387 1.0042C18.7997 -0.334734 16.6289 -0.334734 15.2899 1.0042C13.951 2.34317 13.951 4.514 15.2899 5.85292L41.437 31.9999L15.2899 58.147C13.951 59.4859 13.951 61.6567 15.2899 62.9957Z"
  />
</template>
